export default __webpack_public_path__ + "static/media/Ballroll_00321.024fc570.png";